<template>
  <span
    :is="hierarchy"
    class="cordel-typography-title"
  >
    <slot />
  </span>
</template>

<script>
  const HIERARCHY = ['h1', 'h2', 'h3', 'h4'];

  export default {
    name: 'CordelTypographyTitle',
    props: {
      hierarchy: {
        type: String,
        default: HIERARCHY[1],
        validator(value) {
          return HIERARCHY.includes(value);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-typography-title {
    font-weight: var(--cordel-legacy-font-weight-bold);

    @at-root {
      h1#{&} {
        font-size: var(--cordel-legacy-font-size-xxxl);

        @media all and (max-width: $cordel-breakpoint-mobile) {
          font-size: var(--cordel-legacy-font-size-xxl);
        }
      }

      h2#{&} {
        font-size: var(--cordel-legacy-font-size-xxl);

        @media all and (max-width: $cordel-breakpoint-mobile) {
          font-size: var(--cordel-legacy-font-size-xl);
        }
      }

      h3#{&} {
        font-size: var(--cordel-legacy-font-size-xl);

        @media all and (max-width: $cordel-breakpoint-mobile) {
          font-size: var(--cordel-legacy-font-size-l);
        }
      }

      h4#{&} {
        font-size: var(--cordel-legacy-font-size-l);

        @media all and (max-width: $cordel-breakpoint-mobile) {
          font-size: var(--cordel-legacy-font-size-m);
        }
      }
    }
  }
</style>
